export const config = {
  intro: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#dd8f1d',
      '#ffdd80',
      '#fffdbd',
      '#ffed75',
      '#dd8e1d',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  mult_land: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#dd8f1d',
      '#ffdd80',
      '#fffdbd',
      '#ffed75',
      '#dd8e1d',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
    fontSize: 70,
  },
  mult_port: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#dd8f1d',
      '#ffdd80',
      '#fffdbd',
      '#ffed75',
      '#dd8e1d',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
    fontSize: 70,
  },
  total_win: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#dd8f1d',
      '#ffdd80',
      '#fffdbd',
      '#ffed75',
      '#dd8e1d',
    ],
    strokeThickness: 0,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
    fontSize: 50,
  },
}
